import { updateDashboardMutation } from '@akin-home/dashboards/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { dashboard_query_keys } from './query_keys';

export const useUpdateDashboard = () => {
  const query_client = useQueryClient();

  return useMutation(updateDashboardMutation, {
    onSuccess({ data }) {
      query_client.invalidateQueries(dashboard_query_keys.lists());

      query_client.setQueryData(
        dashboard_query_keys.detail(data.updateDashboard?.id),
        () => data.updateDashboard
      );
    },
  });
};
